import { capitalize } from '@polyseme/utils/string/string-utils';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';
import { footerLinks } from '~/landing/components/shared/sections';

const { brand, links, medias } = {
  brand: 'Germen',
  links: footerLinks,
  medias: [
    { name: 'linkedin', url: images.social.linkedin },
    { name: 'instagram', url: images.social.instagram },
    { name: 'youtube', url: images.social.youtube },
  ],
} as const;

const FooterNavLink = ({
  href,
  children,
  className,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <a
    className={`text-muted-foreground transition-colors hover:text-primary ${className}`}
    href={href}
    rel="noopener noreferrer"
    target="_blank"
  >
    {children}
  </a>
);

export const Footer = () => {
  const t = useTranslations('landing.common.footer');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="space-y-10 border-t bg-background px-20 py-10 text-foreground">
      <div className="mx-auto max-w-screen-xl space-y-6 px-4 py-5 lg:px-0">
        <div className="flex flex-col items-center justify-between gap-8 xl:flex-row">
          <span className="text-center text-sm text-muted-foreground lg:text-start">
            {t('copyright', { year: String(currentYear), brand })}
          </span>

          <nav className="flex flex-wrap items-center gap-5">
            {links.map(({ key, href }) => (
              <FooterNavLink key={key} href={href}>
                {t(`links.${key}`)}
              </FooterNavLink>
            ))}
          </nav>
        </div>

        <nav className="flex items-center justify-end gap-4">
          {medias.map(({ name, url }) => (
            <a
              key={name}
              aria-label={capitalize(`${name} ${brand}`)}
              className="rounded-full p-4 transition-colors hover:bg-secondary"
              href="#"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Image alt={name} height={16} src={url} width={16} />
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
};
